import { fetcher } from 'services/helpers/responseHandler'

// Chat Response
const chatRespond = async (subsidiaryId, propertyId, message, conversationId) => {
  return fetcher.post('llm-platform/v1/chat/respond', {
    message,
    conversationId: conversationId || null,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Campaign Generation
const generateCampaign = async (subsidiaryId, propertyId, goal, channel, tone, variantCount) => {
  return fetcher.post('llm-platform/v1/campaign/generate', {
    goal,
    channel,
    tone,
    variantCount: variantCount,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// CSM Copilot
const csmAnswer = async (subsidiaryId, propertyId, question) => {
  return fetcher.post('llm-platform/v1/csm/answer', {
    question,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Forecast
const getForecast = async (subsidiaryId, propertyId, monthsAhead) => {
  return fetcher.post('llm-platform/v1/forecast/occupancy', {
    monthsAhead: monthsAhead,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Campaign Recommendations
const getCampaignRecommendations = async (subsidiaryId, propertyId, timeWindow) => {
  return fetcher.post('llm-platform/v1/recommend/campaigns', {
    timeWindow: timeWindow,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Intent Classification
const classifyIntent = async (message) => {
  return fetcher.post('llm-platform/v1/intent/classify', {
    message
  })
}

// Directful Assist
const assistRespond = async (
  subsidiaryId,
  propertyId,
  message,
  conversationId,
  channel = 'dashboard',
  audiences = []
) => {
  return fetcher.post('llm-platform/v1/assist/respond', {
    message,
    channel,
    conversationId: conversationId || null,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null,
    audiences: audiences || []
  })
}

const getDripProposal = async (subsidiaryId, propertyId, audiences) => {
  return fetcher.post('llm-platform/v1/assist/drip-proposal', {
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null,
    audiences: audiences || []
  })
}

const getCurrentTimeWindow = () => {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  return `${now.getFullYear()}-${month}`
}

const resolveDripProposal = async (subsidiaryId, propertyId, audiences) => {
  try {
    return await getDripProposal(subsidiaryId, propertyId, audiences)
  } catch (error) {
    if (error?.status !== 404) {
      throw error
    }

    return getCampaignRecommendations(subsidiaryId, propertyId, getCurrentTimeWindow())
  }
}

const getAssistBriefing = async (subsidiaryId, propertyId) => {
  const params = new URLSearchParams()
  if (subsidiaryId) params.append('subsidiaryId', subsidiaryId)
  if (propertyId) params.append('propertyId', propertyId)
  return fetcher.get(`llm-platform/v1/assist/briefing?${params.toString()}`)
}

const getAssistTasks = async (subsidiaryId, state = 'open') => {
  const params = new URLSearchParams()
  if (subsidiaryId) params.append('subsidiaryId', subsidiaryId)
  if (state) params.append('state', state)
  return fetcher.get(`llm-platform/v1/assist/tasks?${params.toString()}`)
}

const confirmAssistTask = async (
  taskId,
  confirmationToken,
  subsidiaryId,
  channel = 'dashboard',
  conversationId = null
) => {
  return fetcher.post(`llm-platform/v1/assist/tasks/${taskId}/confirm`, {
    confirmationToken,
    channel,
    subsidiaryId,
    conversationId: conversationId || null
  })
}

const declineAssistTask = async (
  taskId,
  subsidiaryId,
  conversationId = null,
  confirmationToken = null
) => {
  const params = new URLSearchParams()
  if (subsidiaryId) params.append('subsidiaryId', subsidiaryId)
  if (conversationId) params.append('conversationId', conversationId)
  if (confirmationToken) params.append('confirmationToken', confirmationToken)
  const query = params.toString()
  return fetcher.post(
    `llm-platform/v1/assist/tasks/${taskId}/decline${query ? `?${query}` : ''}`,
    {}
  )
}

const getAssistDripProposal = async (subsidiaryId, audiences, complimentaryCredits = 0) =>
  fetcher.post('llm-platform/v1/assist/drip-proposal', {
    subsidiaryId,
    audiences,
    complimentaryCredits
  })

const llmPlatformApi = {
  chatRespond,
  generateCampaign,
  csmAnswer,
  getForecast,
  getCampaignRecommendations,
  classifyIntent,
  assistRespond,
  getDripProposal,
  resolveDripProposal,
  getAssistDripProposal,
  getAssistBriefing,
  getAssistTasks,
  confirmAssistTask,
  declineAssistTask
}

export default llmPlatformApi
